import { MainSliderType } from 'common/types'

export const MainSliderData: MainSliderType[] = [
   {
      img: require('assets/images/Header/MainSlider/imgSlider1-mainpage.jpg'),
      alt: 'Produto 1',
      linkText: ['LIVING ROOM DECOR COLLECTION', 'Start from $ 199.99'],
      cat: 'living-room'
   },
   {
      img: require('assets/images/Header/MainSlider/imgSlider2-mainpage.jpg'),
      alt: 'Produto 2',
      linkText: ['KITCHEN DECORATION', 'Start from $ 50.00'],
      cat: 'kitchen'
   },
   {
      img: require('assets/images/Header/MainSlider/imgSlider3-mainpage.jpg'),
      alt: 'Produto 3',
      linkText: ['BATHROOM UTILITIES', 'Max price $ 200.99'],
      cat: 'bathroom'
   },
   {
      img: require('assets/images/Header/MainSlider/imgSlider4-mainpage.jpg'),
      alt: 'Produto 4',
      linkText: ['BEDROOM PIECES', 'Start from $ 40.99'],
      cat: 'bedroom'
   },
]